<template>
  <div v-if="started_analyze" class="wrapper-sofia" :class="{'no-permissions': !sofiaEnabled}">
    <div v-if="sofiaEnabled">
      <div id="sofia-container" v-once />
      <sofia-filter-modals-vue
        ref="sofia-filter-modals"
        @confirm_filter_values="confirmFilterValues"
        :sofia-filters="sofiaFilters"
      />
    </div>
    <sofia-premium-form-vue v-else info_link_position="body" ref="premium_form"/>
  </div>
  <div v-else class="wrapper-sofia">
    <sofia-welcome-vue/>
  </div>
</template>

<script>
import Vue from 'vue'
import mixins from 'common/mixins.js'

export default {
  name: 'sofia-wrapper-vue',
  components: {
    'sofia-premium-form-vue': () => import(
      /* webpackChunkName: "[request]" */ 'components/sofia/PremiumForm'
    ),
    'sofia-welcome-vue': () => import(
      /* webpackChunkName: "[request]" */ 'components/sofia/Welcome'
    ),
    'sofia-filter-modals-vue': () => import(
      /* webpackChunkName: "[request]" */ 'components/sofia/SofiaFilterModals'
    )
  },
  mixins: [mixins.requests, mixins.translate],
  props: {
    favourite_id: String,
    domain: String,
    sofiaFilters: { type: Array, default: () => [] },
    userPermissionModules: { type: Array, default: () => [] }
  },
  data() {
    return {
      started_analyze: false
    }
  },
  computed: {
    sofiaEnabled() {
      return this.userPermissionModules.includes('sofia')
    },
    enabled_favourites() {
      return this.favourite_id != ''
    },
    favourite_params() {
      return this.enabled_favourites ? { fav: this.favourite_id } : {}
    }
  },
  methods: {
    buildSofia() {
      const sofiaActions = Sofia.constants.AI_WRITE.ACTIONS
      return new Sofia({
        config: {
          textModes: [Sofia.constants.TEXT_MODE.SELECTION],
          closeButton: { show: false, position: 'left' },
          expandButton: { show: false, position: 'left' },
          events: {
            closeButton: this.close_button_handler,
            expandButton: this.expand_button_handler,
            document: this.document_handler,
            concept: this.concept_handler,
            openFilterModal: this.openFilterModal
          },
          lang: this.$language,
          tolgeo: gon.app_tolgeo,
          paisiso: gon.paisiso,
          defaultMessage: 'Seleccione texto para analizar',
          automaticWarning: true,
          getTokenFunction: this.get_token,
          favourites: this.enabled_favourites,
          formsFirst: false,
          endpoint: this.$sofia_service_url + '/',
          initialDomain: this.domain,
          aiWrite: {
            actions: [
              sofiaActions.SIMPLIFY_TEXT,
              sofiaActions.EXTRACT_MAIN_IDEAS,
              sofiaActions.SCHEMATIZE_TEXT,
              sofiaActions.EXTRACT_RELATED_IDEAS,
              sofiaActions.SUMMARIZE_TEXT,
              sofiaActions.GENERATE_CONCEPTUAL_MAP
            ],
            applyResult: {
              translation: this.t('components.sofia.wrapper.copy_to_clipboard'),
              clean: false
            }
          },
          sofiaFilters: this.sofiaFilters
        },
        buttons: [],
        expanded: true,
        permissions: this.userPermissionModules
      })
    },
    render_sofia() {
      this.sofia.render('sofia-container');
    },
    async analyze(text, quotes_id, reject_ids) {
      if (!this.started_analyze) {
        this.started_analyze = true
        await Vue.nextTick()
        this.render_sofia()
      }
      this.scrollToTop()
      this.sofia.eventBus.publish('ai-analyze:executed')
      await this.sofia.analyze(text,'',quotes_id,reject_ids)
      this.scrollToTop()
    },
    close_button_handler() {},
    expand_button_handler() {},
    document_handler(docid) {
      var event = new CustomEvent('document-quick-view', { detail: { documentId: docid } })
      window.parent.document.dispatchEvent(event)
    },
    concept_handler() {},
    async get_token() {
      return this.get_service_token('sofia', this.favourite_params);
    },
    scrollToTop() {
      document.body.scrollIntoView({behavior: "smooth"})
    },
    sofiaAiWriteExecuteAction(key, params) {
      this.sofia.eventBus.publish('ai-write:action-executed', key, params)
    },
    sofiaChangeSelection(status) {
      this.sofia.eventBus.publish('selection-changed', status)
    },
    openFilterModal(selectedModal) {
      this.$refs['sofia-filter-modals'].showModal(
        selectedModal.tipoid,
        selectedModal.field
      )
    },
    confirmFilterValues(tipoid, name, selectedValues) {
      this.sofia.setSofiaFilterValues(tipoid, name, selectedValues)
    }
  },
  mounted() {
    this.sofia = this.buildSofia()

    document.addEventListener("sofia-analyze", (event) => {
      this.lastAnalysisData = {
        text: event.detail.text,
        quotes_id: event.detail.quotes_id,
        document_ids: [event.detail.document_id]
      }
      this.analyze(event.detail.text, event.detail.quotes_id, [event.detail.document_id])
    })

    this.sofia.eventBus.subscribe('sofia:modal-cleared',(tipoid, field) => {
      this.$refs['sofia-filter-modals'].clearModal(tipoid, field)
    })

    document.addEventListener('sofia:selection-changed', (event) => {
      this.sofiaChangeSelection(event.detail.status)
    })

    this.sofia.eventBus.subscribe('ai-write:action-requested', (key, params) => {
      document.dispatchEvent(new CustomEvent('sofia:ai-write:action-requested', {
        detail: { key: key, params: params }
      }))
    })

    this.sofia.eventBus.subscribe('sofia:analysis-domain-changed', () => {
      this.analyze(
        this.lastAnalysisData.text,
        this.lastAnalysisData.quotes_id,
        this.lastAnalysisData.document_ids
      )
    })

    document.addEventListener('sofia:ai-write:action-executed', (event) => {
      this.sofiaAiWriteExecuteAction(event.detail.key, event.detail.params)
    })

    this.sofia.eventBus.subscribe('ai-write:result-applied', (text) => {
      document.dispatchEvent(new CustomEvent('sofia:ai-write:result-applied', {
        detail: { text: text }
      }))
    })
  }
}
</script>
